<template>
  <Transition
    enter-active-class="transition-opacity duration-200"
    enter-from-class="opacity-0"
    leave-active-class="transition-opacity duration-200"
    leave-to-class="opacity-0"
  >
    <button
      v-show="!store.isOpen"
      :aria-label="i18n(translations.ariaLabel)"
      class="bg-static-ai-mid fixed bottom-24 right-24 z-[9] flex items-center gap-8 rounded-lg p-12 shadow-middle"
      data-test="shopping-assistant-fab"
      type="button"
      @click="handleClick"
    >
      <IconCommentWithSparkles size="24" />

      <!-- Text content: only on desktop -->
      <span class="hidden flex-col items-start md:flex">
        <span class="caption text-action-ai-hi">{{
          i18n(translations.overline)
        }}</span>
        <span class="body-2-bold text-onaction-ai-mid">{{
          i18n(translations.message)
        }}</span>
      </span>
    </button>
  </Transition>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { IconCommentWithSparkles } from '@ds/icons/IconCommentWithSparkles'

import { useShoppingAssistantWebSidebar } from '../stores/useShoppingAssistantWebSidebar'

import translations from './WebSidebarShoppingAssistantFAB.translations'

const i18n = useI18n()
const tracking = useTracking()
const store = useShoppingAssistantWebSidebar()

function handleClick() {
  store.open({ entryPoint: 'floating_button' })
  tracking.trackClick({
    zone: 'floating_button',
    name: 'ai_shopping_assistant_opened',
    entryPoint: 'floating_button',
    seeded: false,
  })
}
</script>
